import { IconComponent } from './types';

const OffsetIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 7 7"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={0.5}
      d="M0-.25h6"
      transform="matrix(0 1 -.99955 -.03006 4.697 0)"
    />
    <path
      stroke="currentColor"
      strokeWidth={0.5}
      d="M0-.25h6"
      transform="matrix(0 1 -.99955 -.03006 .03 0)"
    />
    <path
      stroke="currentColor"
      strokeWidth={0.5}
      d="M0-.25h6"
      transform="matrix(0 1 -.99955 -.03006 5.97 0)"
    />
    <path
      stroke="currentColor"
      strokeWidth={0.5}
      d="M0-.25h6"
      transform="matrix(0 1 -.99955 -.03006 1.303 0)"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m3.55 2.064.865 1.067c.053.066.055.171.003.235l-.833 1.045c-.05.064-.135.063-.188-.003a.196.196 0 0 1-.004-.235l.61-.764-2.496-.034-.005-.332 2.496.034-.633-.78a.196.196 0 0 1-.003-.236c.05-.064.135-.063.188.003Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m4.415 3.131-.096.077.096-.077ZM3.55 2.064l.097-.077-.097.077Zm.868 1.302-.098-.08.098.08Zm-.833 1.045.099.08-.099-.08Zm-.188-.003-.097.077.097-.077Zm-.004-.235.099.08-.099-.08Zm.61-.764.098.08.16-.201-.26-.004.002.125Zm-2.496-.034-.125-.001.002.125.125.001-.002-.125Zm-.005-.332L1.5 2.918l-.125-.001.002.125.125.001Zm2.496.034L4 3.202l.26.004L4.095 3l-.096.077Zm-.633-.78.096-.078-.096.077Zm-.003-.236-.099-.08.099.08Zm1.15.993-.865-1.067-.193.154.865 1.067.192-.154Zm.005.392a.32.32 0 0 0-.006-.392l-.192.154c.015.02.016.06 0 .078l.198.16ZM3.684 4.49l.833-1.044-.197-.16-.833 1.045.197.16ZM3.3 4.485c.049.06.118.097.194.098a.238.238 0 0 0 .19-.093l-.197-.159-.003.003a.014.014 0 0 1 .006-.001l.006.001-.003-.003-.193.154Zm-.005-.391a.32.32 0 0 0 .005.391l.193-.154c-.016-.02-.016-.06-.001-.078l-.197-.16Zm.61-.765-.61.765.197.159.61-.764-.198-.16ZM1.508 3.5l2.496.034L4 3.284 1.505 3.25l.004.25Zm-.132-.458.005.332.25.003-.005-.332-.25-.003Zm2.619-.09L1.5 2.918l.004.25L4 3.202l-.004-.25Zm-.727-.579.633.781L4.094 3l-.633-.78-.192.153Zm-.006-.391a.32.32 0 0 0 .006.391l.192-.154c-.015-.02-.016-.06 0-.078l-.198-.16Zm.384.005a.254.254 0 0 0-.194-.098.238.238 0 0 0-.19.093l.197.159.003-.003a.014.014 0 0 1-.006.001l-.006-.001.003.003.193-.154Z"
    />
  </svg>
);
export default OffsetIcon;
